import { doorClient } from '..';

/**
 * @attention 由于tts官方接口还未提供相关信息，目前talk结构返回结果中增加tiktok_trade_uid字段，如果该值不为空，则tradeUid已经同步了，否则需要发起同步tradeUid请求。
 * @description tiktok订单中的买家id.
 * @reference https://leyan.yuque.com/czpqnb/yzt2rg/xsm5iqec8b99amt3
 */
// eslint-disable-next-line import/prefer-default-export
export const syncTiktokTradeUid = (conversationId: string | number) => {
  return doorClient.get('/oversea-conversation/v1/buyer/syncTiktokTradeUid', {
    params: { conversationId },
  });
};
